import React, { useState, useEffect } from "react";
import cx from "classnames";
import { host } from "@Api";
import { fetchUserNav } from "@Services/nav";

const { www, c } = host;
interface IUserNav {
  nav?: any[];
  memberName?: string;
  unread?: string;
  isSeller?: boolean;
}

const UserPopover: React.FunctionComponent<{ text?: string }> = ({ text }) => {
  const [userNav, setUserNav] = useState<IUserNav>({});

  async function fetch() {
    try {
      const data = await fetchUserNav();
      if (data.status === 12000) {
        setUserNav(data.data);
      }
    } catch (e) {}
  }

  useEffect(() => {
    fetch();
  }, []);

  const { nav, memberName, unread, isSeller } = userNav;

  if (nav) {
    return (
      <>
        <span className='tc-top-nav-right-link text-[#1D2029] flex items-center hover:text-[#1D2029]'>
          <a className='tc-top-nav-logout' href={`${www}/user-logout.html`}>
            登出
          </a>
          <span className='tc-top-nav-member-name'> {Number(memberName) > 99 ? "99+" : memberName} </span>
          <a className='tc-top-nav-msg' href={`${www}/member-msg.html?flag=msg`} target='_blank'>
            {unread}
          </a>
        </span>
        <div className='tc-top-nav-right-popover nav-profile'>
          <h3>
            <a href={`${c}/photoMember-index.html`} target='_blank'>
              新車會員中心
            </a>
          </h3>
          <span className='tc-top-nav-right-dividing' />
          <h3 style={{ marginTop: 20 }}>
            <a href={`${www}/member-index.html`} target='_blank'>
              中古車會員中心
            </a>
          </h3>
          {nav.map((item, index) => (
            <div key={index}>
              <p className='nav-profile-title' style={{ color: item.titleColor }}>
                {item.title}
              </p>
              <div className={cx("nav-profile-row", { split: !isSeller })}>
                {item.items.map((ii: any) => {
                  // if
                  return (
                    <a
                      className='nav-profile-col'
                      style={{ color: ii.color }}
                      href={ii.link}
                      key={ii.name}
                      target='_blank'
                    >
                      {ii.name}
                    </a>
                  );
                })}
              </div>
              {!!isSeller && <span className='tc-top-nav-right-dividing'></span>}
            </div>
          ))}
          {!!isSeller && (
            <div className='nav-profile-row'>
              <a className='nav-profile-col' style={{ marginTop: 0 }} href={`${www}/member-index.html`} target='_blank'>
                更多內容
              </a>
            </div>
          )}
        </div>
      </>
    );
  }
  return (
    <a
      className='tc-top-nav-right-link flex items-center gap-4 text-[#1D2029] text-14 cursor-pointer m-0'
      href={`${www}/user-signin.html`}
    >
      <img src='https://photo.8891.com.tw/2024/11/07/1730958611621241.png' width={14} height={14} />
      {text || "登入/註冊"}
    </a>
  );
};

export default UserPopover;
